export default __webpack_public_path__ + "static/media/precise-location-ss-selected-focused.18a09901.svg";